module.exports = __webpack_public_path__ + "static/media/trial_plan.dc81e30b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/trial_plan.svg
// module id = 193
// module chunks = 0